import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { GetListDTO } from '../dto'

interface State {
  songs: Record<SongId, Song>
  total: number
}

export enum ListSongsOrderBy {
  TITLE = 'title',
  ARTIST = 'artist',
  CREATED_AT = 'createdAt',
  PLAY_COUNT = 'playCount',
}

export interface EditSongDTO extends Omit<Song, 'createdAt'> {}

type SongId = string
export interface Song {
  _id: string
  title: string
  artist: string
  file: string //filename from uploaded folder
  createdAt: number
  modifiedAt?: number
  duration?: number
  imageUrl?: string
}

type SearchSongsDto = GetListDTO & {
  oderBy?: ListSongsOrderBy
  q?: string
}

export const initialState: State = {
  songs: {},
  total: 0,
}

export const attemptSearchSongs = createAsyncThunk<
  { songs: Song[]; total: number },
  SearchSongsDto
>('songs/search', async (payload) => {
  const response = await $api.post('song/search', payload)
  return response.data
})

export const attemptUpdateSong = createAsyncThunk<Song, EditSongDTO>(
  'songs/update',
  async (payload) => {
    const response = await $api.post(`song/update/${payload._id}`, payload)
    return response.data
  },
)

export const attemptDeleteSong = createAsyncThunk<Song['_id'], Song['_id']>(
  'songs/delete',
  async (songId) => {
    await $api.post(`song/delete/${songId}`)
    return songId
  },
)

export const songsReducer = createSlice({
  name: 'songs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptSearchSongs.fulfilled, (state, { payload }) => {
      state.songs = {}
      payload.songs.forEach((song) => {
        state.songs[song._id] = song
      })
      state.total = payload.total
    })
    builder.addCase(attemptUpdateSong.fulfilled, (state, { payload }) => {
      state.songs[payload._id] = payload
    })
    builder.addCase(attemptDeleteSong.fulfilled, (state, { payload: _id }) => {
      delete state.songs[_id]
    })
  },
})

export const {} = songsReducer.actions
export default songsReducer.reducer
